<p-dialog [(visible)]="showRRule" (onShow)="CreateFormControls()" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'640px': '100vw'}"
    [style]="{width: '500px'}" styleClass="no-header-modal overflow-visible" aria-label="recurrence-rule-dialog">
    <ng-template pTemplate="header" styleClass="hidden"></ng-template>
    <ng-template pTemplate="content" styleClass="p-0">
        <form [formGroup]="formGroup" (ngSubmit)="CreateRRule()" aria-label="recurrence-rule-form">

            <!-- Content -->
            <div class="p-3 surface-50 relative">
                <div class="text-right">
                <i class="fa fa-times text-xl text-600 cursor-pointer" (click)="HideRRule()" data-testid="close-rrule-dialog"></i>
            </div>
                <div class="p-buttonset" aria-label="repeat-frequency-buttons">
                    <button type="button" (click)="Repeat = 'daily'"
                        [ngClass]="Repeat == 'daily' ? '' : 'p-button-secondary' " pButton pRipple
                        label="{{'Shared.RRULE.BUTTON_DAILY' | translate}}"
                        class="text-sm border-right-1 border-white" aria-label="daily-repeat-button"></button>
                    <button type="button" (click)="Repeat = 'weekly'"
                        [ngClass]="Repeat == 'weekly' ? '' : 'p-button-secondary' " pButton pRipple
                        label="{{'Shared.RRULE.BUTTON_WEEKLY' | translate}}"
                        class="text-sm border-right-1 border-white" aria-label="weekly-repeat-button"></button>
                    <button type="button" (click)="Repeat = 'monthly'"
                        [ngClass]="Repeat == 'monthly' ? '' : 'p-button-secondary' " pButton pRipple
                        label="{{'Shared.RRULE.BUTTON_MONTHLY' | translate}}"
                        class="text-sm border-right-1 border-white" aria-label="monthly-repeat-button"></button>
                </div>

                <!-- For Weekly -->
                <div *ngIf="Repeat == 'weekly'" class="my-2" aria-label="weekly-options">
                    <div class="p-buttonset flex mt-3">
                        <button type="button" *ngFor="let weekDay of weekOptions" (click)="AddOrRemoveWeekDays(weekDay)"
                            [ngClass]="WeekDays.includes(weekDay) ? '' : 'p-button-secondary' "
                            class="text-sm border-right-1 border-white h-2rem w-2rem border-circle p-0 flex align-items-center justify-content-center mr-2"
                            pButton pRipple label="{{weekDay.name}}" [aria-label]="'select-' + weekDay.name.toLowerCase() + '-button'"></button>
                    </div>
                </div>
                <!-- For Weekly -->

                <!-- For Monthly -->
                <div *ngIf="Repeat == 'monthly'" class="my-2" aria-label="monthly-options">
                    <h4 class="text-sm mb-2">
                        {{ 'Shared.RRULE.HEADER_REPEATSEVERY' | translate }}
                    </h4>
                    <div class="flex align-items-center">
                        <p-select [options]="monthOptions" formControlName="monthDays" optionLabel="name"
                            placeholder="Select" styleClass="text-sm" aria-label="month-day-selector">
                            <ng-template pTemplate="selectedItem">
                                <div class="text-sm" *ngIf="MonthDays">{{MonthDays.name}}</div>
                            </ng-template>
                            <ng-template let-monthDays pTemplate="item">
                                <div class="text-sm">{{monthDays.name}}</div>
                            </ng-template>
                        </p-select>
                        <span class="ml-2 text-sm">
                            {{ 'Shared.RRULE.SPAN_DAYOFTHEMONTH' | translate }}
                        </span>
                    </div>
                </div>
                <!-- For Monthly -->

                <h4 class="text-sm mb-0 line-height-1 font-bold mt-3" aria-label="stop-conditions-header">
                    {{ 'Shared.RRULE.HEADER_STOPCONDITIONS' | translate }}
                </h4>

                <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-2">

                <ul class="list-none p-0 m-0 text-sm" aria-label="stop-conditions-list">
                    <li class="mt-2 flex align-items-start" *ngIf="!showNeverStop">
                        <p-radioButton name="repeatableRule" value="1" formControlName="repeatableRule"
                            inputId="option1" aria-label="until-membership-option">
                        </p-radioButton>
                        <label class="ml-2" for="option1">
                            {{ 'Shared.RRULE.LABEL_UNTILMEMBERSHIPLASTS' | translate }}
                            <span class="text-xxs text-500 block">
                                {{ 'Shared.RRULE.SPAN_UNTILMEMBERSHIPLASTS' | translate }}
                            </span>
                        </label>
                    </li>
                    <li class="mt-2 flex align-items-start" *ngIf="showNeverStop">
                        <p-radioButton name="repeatableRule" value="2" formControlName="repeatableRule"
                            inputId="option2" aria-label="never-stop-option">
                        </p-radioButton>
                        <label class="ml-2" for="option2">
                            {{ 'Shared.RRULE.LABEL_NEVERSTOP' | translate }}
                            <span class="text-xxs text-500 block">
                                {{ 'Shared.RRULE.SPAN_NEVERSTOP' | translate }}
                            </span>
                        </label>
                    </li>
                    <li class="mt-2 flex align-items-start">
                        <p-radioButton name="repeatableRule" value="3" formControlName="repeatableRule"
                            inputId="option3" styleClass="mt-2" aria-label="run-until-date-option">
                        </p-radioButton>
                        <label class="ml-2" for="option3">
                            {{ 'Shared.RRULE.LABEL_RUNUNTILDATE' | translate }}
                            <p-datepicker placeholder="Select Date" formControlName="until" inputStyleClass="text-sm"
                                styleClass="" [minDate]="minimumDate" tabindex="0" aria-label="end-date-picker">
                            </p-datepicker>
                            <span class="text-xxs text-500 block">
                                {{ 'Shared.RRULE.SPAN_RUNUNTILDATE' | translate }}
                            </span>
                        </label>
                    </li>
                    <li class="mt-3 flex align-items-start">
                        <p-radioButton name="repeatableRule" value="4" formControlName="repeatableRule"
                            inputId="option4" aria-label="run-until-count-option">
                        </p-radioButton>
                        <label class="ml-2" for="option4">
                            <span class="flex">
                                {{ 'Shared.RRULE.SPAN_UNTILCOUNT' | translate }}
                                <app-input-number [formGroup]="formGroup" [controlName]="formGroup.get('count')" 
                                [styleClass]="'w-3rem h-2rem -mt-2 mx-2'" [conditionToFormat]="false" aria-label="occurrence-count-input">
                               </app-input-number>
                                {{ 'Shared.RRULE.SPAN_UNTILCOUNTOCCURENCE' | translate }}
                            </span>
                            <span class="text-xxs text-500 block">
                                {{ 'Shared.RRULE.SPAN_UNTILCOUNTDESCRIPTION' | translate }}
                            </span>
                        </label>
                    </li>
                </ul>
            </div>
            <!-- Content -->

            <!-- Modal Footer -->
            <div class="px-3 md:px-4 py-3 border-top-1 border-300">
                <div class="flex align-items-center justify-content-between">
                    <p-button styleClass="p-button-link text-sm" (click)="HideRRule()"
                        label="{{ 'Shared.RRULE.BUTTON_CANCEL' | translate }}" aria-label="cancel-rrule-button">
                    </p-button>
                    <button type="submit" class="text-sm" pButton pRipple
                        label="{{ 'Shared.RRULE.BUTTON_SAVE' | translate }}" aria-label="save-rrule-button"></button>
                </div>
            </div>
            <!-- Modal Footer -->

        </form>
    </ng-template>
</p-dialog>